module.exports = __webpack_public_path__ + "img/french-01.76a41c43.png";